let isLoadedMathjax = false
export default {
    
  initConfig: function () {
    setTimeout(function(){
      if (isLoadedMathjax) {
        return
      }
      if (typeof window.MathJax !== 'undefined' && window.MathJax !== 'undefined') {
        isLoadedMathjax = true
        window.MathJax.Hub.Configured()
      }
    },3000)
    
  },
  renderMathjax (nodes) {
    if (typeof window.MathJax !== 'undefined' && window.MathJax.Hub) {
      if (!isLoadedMathjax) {
        this.initConfig()
      }
      window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, nodes])
    }
  }
}